export default "__VITE_ASSET__75112a0f__"